var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * This script is used in the search page of the vital proteins site
 * (https://www.vitalproteins.com/pages/search-results-page)
 *
 * This page is wholly constructed by the Smart Search & Instant Search plugin
 * by Searchanise.
 *
 * Here we are only hooking into the events fired by that plugin.
 */
import * as React from 'react';
import * as ReactDom from 'react-dom';
const $ = window.$;
import { API } from '../data/API';
import { VitalLoader } from '../components/VitalLoader';
$(document).on('Searchanise.AddToCartSuccess', function (event, addToCartID, itemData) {
    window.location.href = '/cart';
});
window.cachedSearch = {};
window.cachedSearchCards = {};
$(document).on('Searchanise.ResultsUpdated', function (event, content) {
    return __awaiter(this, void 0, void 0, function* () {
        var products = $('.snize-product');
        var snizePrefix = 'snize-product-';
        //hide all products and show loader
        const parent = $('.snize-product').parent();
        parent.hide();
        //check if loader already exists and use it or create it
        if ($('.vitaloader-searchnise').length > 0) {
            $('.vitaloader-searchnise').show();
        }
        else {
            $(parent).before(`<div class="vitaloader-searchnise flex items-center justify-center"/>`);
            ReactDom.render(React.createElement(VitalLoader, null), $('.vitaloader-searchnise')[0]);
        }
        for (let productElement of products) {
            let productID = $(productElement).attr('id');
            $(productElement).css('display', 'flex');
            $(productElement).addClass('tailwind');
            if (productID) {
                productID = productID.replace(snizePrefix, '');
                productID = parseInt(productID);
                let productInfo;
                if (window.cachedSearch[productID]) {
                    productInfo = window.cachedSearch[productID];
                }
                else {
                    productInfo = (yield API.Backend.getProduct(productID)).data.products
                        .edges[0].node;
                    window.cachedSearch[productID] = productInfo;
                }
                if (!productInfo.onlineStoreUrl) {
                    continue;
                }
                if (!window.cachedSearchCards[productID]) {
                    const { pathname } = new URL(productInfo.onlineStoreUrl);
                    window.cachedSearchCards[productID] = yield (yield fetch(`${pathname}?view=search-card`)).text();
                }
                productElement.innerHTML = window.cachedSearchCards[productID];
            }
        }
        //hide loader and show products
        $('.vitaloader-searchnise').hide();
        parent.show();
        dynamicImagesHandler();
    });
});
function updateObjectFit(img) {
    if (img.naturalWidth == img.naturalHeight) {
        img.style.objectFit = 'cover';
    }
    else {
        img.style.objectFit = 'contain';
    }
}
function dynamicImagesHandler() {
    const dynamicImages = document.getElementsByClassName('dynamic');
    if (dynamicImages.length === 0)
        return;
    Array.from(dynamicImages).forEach(updateObjectFit);
}
